import { call, put, takeLatest } from "redux-saga/effects";
import {
  getPortDetail,
  getPortDetailFailure,
  getPortDetailSuccess,
  getSecurityDetail,
  getSecurityDetailFailure,
  getSecurityDetailSuccess,
} from "redux/reducers/primary-port";
import { ProductAPI } from "services/product";

function* getPortDetailSaga({ payload }) {
  try {
    if (payload.searchType) {
      const response = yield call(ProductAPI.getPortDetail, {
        searchType: payload.searchType,
        searchValue: payload.searchValue,
      });

      if (response.data.result.security) {
        response.data.result.security.sort((a, b) => b.percent - a.percent);
      }

      yield put(getPortDetailSuccess(response.data.result));
    }
  } catch (error) {
    yield put(getPortDetailFailure(error));
  }
}

function* getSecurityDetailSaga({ payload }) {
  try {
    const response = yield call(ProductAPI.getSecurityDetail, payload);
    yield put(getSecurityDetailSuccess(response.data.result));
  } catch (error) {
    yield put(getSecurityDetailFailure(error));
  }
}

const saga = [
  takeLatest(getPortDetail.type, getPortDetailSaga),
  takeLatest(getSecurityDetail.type, getSecurityDetailSaga),
];

export default saga;
